import { render, staticRenderFns } from "./ViewRequest.vue?vue&type=template&id=67d246a6&scoped=true&"
import script from "./ViewRequest.vue?vue&type=script&lang=js&"
export * from "./ViewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d246a6",
  null
  
)

export default component.exports